<template>
<!-- 과정항목 관리 팝업 -->
<div class="modal fade" id="enrollDetail" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered w-400px" role="document">
        <div class="modal-content">
            <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn">
                </span>
            </a>
            <div class="modal-body">
                <div>
                    <h3 class="font-15 bold">상세 및 기타</h3>
                    <div>
                        <span class="font-13 bold">과정: {{subjectName}}</span>
                    </div>
                    <div class="mt-10 mb-10">
                        <textarea v-model="text" class="w-100per h-150px pt-05"></textarea>
                    </div>
                    <span>* 입력 내용은 페이지 하단 저장을 눌러야 저장됩니다.</span>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <a class="admin-btn-default btn pointer" @click="exportData()" data-dismiss="modal" aria-label="Close">입력 완료</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['gridIndex', 'rowIndex', 'parentDetail', 'parentSubjectName'],
    data: () => ({
        text: '',
        subjectName: ''
    }),
    mounted() {
        if (this.parentDetail !== '') {
            this.text = this.parentDetail
        }

        this.subjectName = this.parentSubjectName
    },

    beforeDestroy() {},

    methods: {
        exportData() {
            this.$emit('applyDetail', this.text, this.gridIndex, this.rowIndex)
        }
    }
}
</script>
